import React from "react";
import { Button } from "@mantine/core";
import { IconDeviceFloppy } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

const SaveButton = ({ onClick, text = "Save Config", color = "blue" }) => {
  const { t } = useTranslation();

  const buttonText =
    text !== "Save Config"
      ? text
      : t("mixer:microsite_settings:save_config_button");
  return (
    <Button
      mt="lg"
      variant="light"
      onClick={onClick}
      leftSection={<IconDeviceFloppy />}
      color={color}
    >
      {buttonText}
    </Button>
  );
};

export default SaveButton;
